import format from 'date-fns/format'
import React, { useState, useEffect } from 'react'
import { Accordion, AccordionContent, AccordionItem, AccordionTitle, Cell, Grid } from 'react-foundation'
import AppNotification from '../../models/Notification'
import { ApiFetch } from './Api'
import { DataLoading } from './Table'

type ViewNotificatonDetailsProps = {
    notificationID: number
    preContent: string
    postContent: string
}

const ViewNotificatonDetails: React.FC<ViewNotificatonDetailsProps> = ({ notificationID, preContent, postContent }) => {
    const [notification, setNotification] = useState<AppNotification>()
    const [open, setOpen] = useState(false)

    const [hasOpened, setHasOpened] = useState(0)


    useEffect(()=>{
        if(!hasOpened && !open)
            return

        //Already pulled this data...
        if(notificationID === hasOpened)
            return

        ApiFetch<AppNotification>(`Notification/${notificationID}`)
        .then(
            (result) => {
                setHasOpened(notificationID)
                setNotification(result)
            })
            // eslint-disable-next-line no-console
            .catch(console.log)
    }, [notificationID, open, hasOpened])

    return <Accordion>
        <AccordionItem>
            <AccordionTitle onClick={() => setOpen(!open)}>
                {preContent} {postContent}
                <span className='is-active'>
                    {open ? <i className='fa fa-minus'></i> : <i className='fa fa-plus'></i>}
                </span>
            </AccordionTitle>
            <AccordionContent isActive={open}>
                {!hasOpened && <DataLoading />}
                {notification && <Grid>
                    <Cell large={3}>
                        <strong>Subject:</strong>
                    </Cell>
                    <Cell large={9}>
                        {notification.subject}
                    </Cell>
                    <Cell large={3}>
                        <strong>Recipient(s):</strong>
                    </Cell>
                    <Cell large={9}>
                        {notification.emails && notification.emails.map((email, i: number)=><div key={i}>
                            {email.providerName && email.emailAddress ? `${email.providerName} <${email.emailAddress}>` : email.emailAddress}
                            &nbsp;&nbsp;&nbsp;
                            {!email.emailSentDate && email.failureMessage && <>(Not Sent: {email.failureMessage})</>}
                            {!email.emailSentDate && !email.failureMessage && <>(Pending)</>}
                            {email.emailSentDate && <>(Sent on {format(new Date(email.emailSentDate),'M/d/yyyy p')})</>}
                        </div>)}
                        {!notification.emails && <div>Could not find receipient list</div>}
                    </Cell>
                </Grid>}
            </AccordionContent>
        </AccordionItem>
    </Accordion>
}

export default ViewNotificatonDetails